import { Controller } from "stimulus"

// Stimulus controller for Bootstrap 4 modals
export default class extends Controller {
  connect() {
    // After appendChild moves this element to body, Stimulus creates a NEW
    // controller instance for the re-connect. Use a DOM attribute (persists
    // across instances) to detect we've already initialized.
    if (this.element.dataset.modalReady) return

    this.element.dataset.modalReady = "true"
    document.body.appendChild(this.element)

    $(this.element).modal("show")

    $(this.element).on("hidden.bs.modal", () => {
      document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
      document.body.classList.remove("modal-open")
      this.element.remove()
    })
  }

  disconnect() {
    // If element is on body, this is the intermediate disconnect from the
    // appendChild move — not a real teardown. Skip cleanup.
    if (this.element.parentElement === document.body) return

    $(this.element).modal("hide")
    document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
    document.body.classList.remove("modal-open")
  }
}
